import get from 'lodash/get';
import PropTypes from 'prop-types';

import ModalHandlerComponent from '../Modal/ModalHandlerComponent';
import SortableTableComponent from '../Table/SortableTableComponent';
import GiveAccessComponent from './GiveAccessComponent';

import { customSorting, toSentenceCase } from '../../utils';
import { getFullName } from '../Person/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';
import { GIVE_ACCESS } from './constants';

import CellPersonWithImage from '../Table/CellPersonWithImage';
import { StyledCallCenterTableContainer } from './styledComponents';

const getRoles = (roles) => {
  if (!roles?.length) return null;
  return [
    ...new Set(roles.map(({ roleName }) => toSentenceCase(roleName))),
  ].join(', ');
};

const getUnits = (roles) => {
  if (!roles?.length) return null;
  return [...new Set(roles.map(({ propertyName }) => propertyName))].join(', ');
};

const CallCenterResidentComponent = ({
  persons,
  modal,
  modalProps,
  onModalShow,
  onOpenAccessPointForResident,
  requirePhotoForVisitorLockout,
}) => {
  const columns = [
    {
      Header: 'Name',
      id: 'name',
      headerClassName: 'sort',
      minWidth: 200,
      accessor: (person) => <CellPersonWithImage person={person} />,
      filter: true,
      sortMethod: (a, b) =>
        customSorting(
          get(a, 'props.person.firstName', null),
          get(b, 'props.person.firstName', null),
        ),
      dataKey: (person) => getFullName(person),
    },
    {
      Header: 'Unit',
      id: 'unitName',
      accessor: ({ roles }) => getUnits(roles),
      headerClassName: 'sort',
      dataKey: ({ roles }) => getUnits(roles),
      filter: true,
    },
    {
      Header: 'Role',
      id: 'role',
      accessor: ({ roles }) => getRoles(roles),
      headerClassName: 'sort',
      dataKey: ({ roles }) => getRoles(roles),
      filter: true,
    },
  ];

  const onRowClick = (rowInfo) => onModalShow(GIVE_ACCESS, rowInfo?.original);

  const rowStyles = {
    style: {
      cursor: 'pointer',
    },
  };

  const isStaffSelected = modal?.data?.roles?.find(({ isStaff }) => isStaff);
  const disableIfNoPhoto = requirePhotoForVisitorLockout && !isStaffSelected;

  return (
    <section>
      <StyledCallCenterTableContainer>
        <SortableTableComponent
          tableId={TABLE_ID.ccResidents}
          title="CC - Residents / Staff"
          columns={columns}
          defaultSort={TABLE_CONSTANTS.name}
          entries={persons}
          tableDataType={null}
          onRowClick={onRowClick}
          rowStyles={rowStyles}
        />
      </StyledCallCenterTableContainer>
      {modal?.type === GIVE_ACCESS && (
        <ModalHandlerComponent {...modalProps}>
          <GiveAccessComponent
            buttonLabel="Give access"
            disabledButtonLabel="Must upload photo for access"
            onOpenAccessPoint={onOpenAccessPointForResident}
            disableIfNoPhoto={disableIfNoPhoto}
            {...modal?.data}
          />
        </ModalHandlerComponent>
      )}
    </section>
  );
};

CallCenterResidentComponent.propTypes = {
  persons: PropTypes.instanceOf(Array).isRequired,
  modal: PropTypes.instanceOf(Object).isRequired,
  onModalShow: PropTypes.func.isRequired,
  onOpenAccessPointForResident: PropTypes.func.isRequired,
  modalProps: PropTypes.instanceOf(Object).isRequired,
  requirePhotoForVisitorLockout: PropTypes.bool,
};

export default CallCenterResidentComponent;
